import React, { useEffect, useRef, useState } from 'react'
import { IGif } from '@giphy/js-types';
import { Carousel } from '@giphy/react-components'
import { gf } from '../api/giphy';

interface GifSearchProps {
  sendGif: (gifId: string) => Promise<void>;
  hideGifSearch: () => void;
}

const GifSeach: React.FC<GifSearchProps> = ({ sendGif, hideGifSearch }) => {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current!.focus();
  }, [])

  const fetchGifs = (offset: number) => gf.search(searchTerm, { offset, limit: 10 });
  const fetchDefault = (offset: number) => gf.emoji({ offset, limit: 10 });

  const handleGifClick = async (gif: IGif, event: React.SyntheticEvent<HTMLElement, Event>) => {
    event.preventDefault();
    await sendGif(gif.id.toString());
    hideGifSearch();
  }

  return (
    <>
      <Carousel
        className='min-h-third scrollbar-thin scrollbar-thumb-gray-600 mb-1'
        gifHeight={200}
        gutter={6}
        fetchGifs={!searchTerm ? fetchDefault : fetchGifs}
        key={searchTerm}
        onGifClick={handleGifClick}
      />
      <input
        className="text-white bg-black bg-opacity-30 mb-1 border-none w-full p-1 placeholder-gray-400 focus:outline-none"
        type="text"
        placeholder="gif search"
        onChange={e => setSearchTerm(e.target.value)}
        ref={inputRef}
      />
    </>
  );
}

export default GifSeach;
